import api from '@/api/agency'

const state = {

}

const actions = {
  getApplicationResumeInfo (context, params) {
    return api.getApplicationResumeInfo(params)
  },
  createCandidateByJob (context, params) {
    return api.createCandidateByJob(params)
  },
  updateCandidateInfo (context, params) {
    return api.updateCandidateInfo(params)
  },
  headhunterUploadCandidatePhoto (context, params) {
    return api.headhunterUploadCandidatePhoto(params.candidateId, params.jobId, params.photo)
  },
  getAgencyList (context, params) {
    return api.getAgencyList(params)
  },
  shareJobToAgency (context, params) {
    return api.shareJobToAgency(params)
  },
  getJobInfoByJobId (context, jobId) {
    return api.getJobInfoByJobId(jobId)
  },
  getAgencyJobList (context, params) {
    return api.getAgencyJobList(params)
  },
  getAgencyJobCompanyList (context, params) {
    return api.getAgencyJobCompanyList(params)
  },
  getAgencyJobApplicationList (context, { jobId, params }) {
    return api.getAgencyJobApplicationList(jobId, params)
  },
  getAgencyJobInfo (context, { jobId }) {
    return api.getAgencyJobInfo(jobId)
  },
  getApplicationIdList (context, params) {
    return api.getApplicationIdList(params)
  },
  getCopyCandidateJobList (context, params) {
    return api.getCopyCandidateJobList(params)
  },
  getAgencyInfoById (context, agencyId) {
    return api.getAgencyInfoById(agencyId)
  },
  createAgency (context, agencyInfo) {
    return api.createAgency(agencyInfo)
  },
  updateAgency (context, agencyInfo) {
    return api.updateAgency(agencyInfo)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
